import { SelectTableModalComponent } from './../select-table-modal/select-table-modal.component';
import { environment } from 'src/environments/environment';
import { Component, Input, EventEmitter, inject } from '@angular/core';
import Order from 'src/smoothr-web-app-core/models/Order';
import { ModalController } from '@ionic/angular';
import { Output } from '@angular/core';

@Component({
	selector: 'app-chip-table',
	templateUrl: './chip-table.component.html',
	styleUrls: ['./chip-table.component.scss'],
	standalone: false,
})
export class ChipTableComponent {
	@Input() order: Order;
	@Output() selectTableModal = new EventEmitter<void>();
	environment = environment;
	private modalCtrl = inject(ModalController);
	async openSelectTable() {
		this.selectTableModal.emit();
	}
}
